import { FlexLayout, H4, Icon } from '@deity/falcon-ui';
import type React from 'react';
import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useGetFlowLazyQuery } from 'services/graphql/generated/hooks';
import { FlowSummary } from './FlowSummary';

type IMappingEditorFooterProps = {
  params: any;
};
const FlowEditorFooter: React.FC<IMappingEditorFooterProps> = ({ params }) => {
  const { pathname } = useLocation();

  const [getFlow, { data: flowData }] = useGetFlowLazyQuery({
    fetchPolicy: 'cache-first'
  });

  useEffect(() => {
    getFlow({
      variables: {
        packageVersionUuid: params.versionUuid,
        uuid: params.entityId
      }
    });
  }, []);

  return (
    <FlexLayout width="full" justifyContent="space-between" alignItems="center">
      <Link
        to={pathname
          .split('/')
          .filter(i => i !== 'editor')
          .join('/')}
        style={{ textDecoration: 'none' }}
      >
        <FlexLayout alignItems="center">
          <Icon src="arrowBack" color="primaryText" stroke="transparent" />
          <H4 fontWeight="bold" color="primaryText" ml="xs">
            {flowData?.getFlow.name}
          </H4>
        </FlexLayout>
      </Link>
      <FlowSummary />
    </FlexLayout>
  );
};

export default FlowEditorFooter;
